// extracted by mini-css-extract-plugin
module.exports = {"base":"HeaderLinks_base__bohHR"};